import { Nullable } from "../../api/types";
import { TestGraph } from "../../types";
import Error from "../Error";
import Loader from "../AppLoader";
import Graph from "./Graph";
import GraphItem from "./GraphsGrid/GraphItem";

export function InterpretationMainGraph({
    show,
    graph,
    loading,
    error,
    refetch,
}: {
    show: boolean;
    graph?: TestGraph;
    loading: boolean;
    error?: Error;
    refetch: () => void;
}) {
    if (!show) return null;

    if (loading) {
        return <Loader />;
    }

    if (error) return <Error />;

    if (!graph) return null;

    return (
        <div>
            <h6
                className="text-black text-lg font-bold h-[30px]"
                dangerouslySetInnerHTML={{ __html: graph.title }}
            />
            <div className="bg-white w-[763px] h-[302px] flex items-center justify-center shadow-[0px_2px_8px_0px_#366CD640]">
                <Graph disabled graphData={graph} size="xl" />
            </div>
        </div>
    );
}

export function InterpretationGraphs({
    graphs,
    loading,
    error,
    asGrid = false,
    refetch,
}: {
    graphs: Nullable<TestGraph[]>;
    loading: boolean;
    error?: Error;
    asGrid?: boolean;
    refetch: () => void;
}) {
    if (loading) {
        return <Loader />;
    }

    if (error) return <Error />;
    if (!graphs) return null;

    return (
        <div
            className={`grow grid grid-cols-2 ${
                asGrid ? "" : "flex justify-between gap-0"
            } gap-x-2 3xl:gap-x-8 gap-y-2 3xl:gap-y-8`}
        >
            {graphs.slice(asGrid ? 0 : 1).map((graph, index) => (
                <GraphItem
                    key={index}
                    graphData={graph}
                    isPartialMode={false}
                    disabled
                />
            ))}
        </div>
    );
}
